<div
  class="flex h-full flex-col overflow-hidden transition-all duration-300"
  [class.w-64]="!isCollapsed"
  [class.w-12]="isCollapsed"
>
  <div class="flex-1">
    <div [class.hidden]="isCollapsed">
      <ng-container #sideMenu></ng-container>
    </div>

    <div [class.hidden]="!isCollapsed">
      <ng-container #collapsedSideMenu></ng-container>
    </div>
  </div>

  <button
    type="button"
    class="mb-8 ml-auto flex h-12 w-12 cursor-pointer items-center justify-center"
    (click)="toggleMenu()"
  >
    <fa-icon [icon]="isCollapsed ? faChevronRight : faChevronLeft"></fa-icon>
  </button>
</div>
